import 'globalthis/polyfill';

var $ = require('jquery');
window.jQuery = $;
window.$ = $;

import 'jquery-ui/ui/widget.js';
import 'jquery-ui/ui/unique-id.js';
import 'jquery-ui/ui/widgets/menu.js';
import 'jquery-ui/ui/keycode.js';
import 'jquery-ui/ui/position.js';
import 'jquery-ui/ui/safe-active-element.js';
import 'jquery-ui/ui/widgets/autocomplete.js';

import Cookies from 'js-cookie';

/** SET GLOBAL USER TYPE */
const cookieUtils = require('./cookie-utils.js');
(() => {
	const ext = cookieUtils.getExternalId();
	const peterwitt = cookieUtils.getPeterwitt();
	const userType = (ext, peterwitt) => {
		if (peterwitt && !ext) return 'prospect';
		if (peterwitt && ext) return 'parco';
		if (!peterwitt && ext) return 'known';
		return 'guest';
	}
	window.userType = userType(ext, peterwitt);
})();

/*
	Nota bene: l'inizializzazione dei video player deve avvenire prima di quella
	dei caroselli.
	Swiper tende a duplicare alcune slides, per scopi interni, ma questo duplica
	anche i rispettivi nodi ed i rispettivi ID, mandando in confusione
	l'inizializzazione del video player Cloudinary
*/
require('./video-player.js');

require('./carousel.js');
require('./carousel-fix.js');
require('./dropdown.js');
require('./hero.js');
require('./menu.js');
require('./text-collapse.js');
require('./transition.js');
require('./modal.js');

$('.cookie-settings-button').click(function(e) {
	if (window._sp_.loadPrivacyManagerModal) {
		e.preventDefault();
		let identifier = $(this).attr('data-identifier');
		window._sp_.loadPrivacyManagerModal(identifier, 'purposes');
	}
});

/*
    Simplified version of
    https://gist.github.com/harryfinn/75e0e3ea48987b7d0c0a
*/
function onscreen(node) {
	if (node.length == 0) {
		return false;
	}

    var vbottom = $(window).scrollTop() + $(window).height() + 200;
    var bottom = node.offset().top + node.outerHeight();
    return (bottom <= vbottom);
}

$(document).ready(() => {
	/*
		Qui posticipo la generazione dell'evento di tracking dell'intera pagina con
		lo scopo di (eventualmente) arricchire il payload con le informazioni che
		trovo in query string
	*/

	const urlParams = new URLSearchParams(window.location.search);
	const query = urlParams.get('q');
	const num_results = urlParams.get('nq');
	if (query && num_results) {
		digitalData.page.category.eventName = "Internal-searches";
		digitalData.page.category.internal_keyword_corporate = query;
		digitalData.page.category.searchResults = num_results;
	}

	if (window.userType === 'parco' || window.userType === 'known') {
		const bannerOnlyParco = document.querySelectorAll('.show_only_parco');
		bannerOnlyParco?.forEach((elem) => {
			elem.style.display = 'block'
		});
	} else {
		const bannerUserTypeDefault = document.querySelectorAll('.show_usertype_default');
		bannerUserTypeDefault?.forEach((elem) => {
			elem.style.display = 'block';
		});
	}

	_satellite.track('programmi', digitalData);
});

$('.infinite-scroll').each(function() {
    var scrollable = $(this);
    var paginator = scrollable.find('.pagination');
    var loading = false;

    $(window).on('scroll', function () {
        /*
            The paginator is used as trigger to execute the next load:
            when it is visible, I am at the bottom of the page
        */
        if (onscreen(paginator) && loading == false) {
            loading = true;
            var next = paginator.find('.page-link');
            paginator.remove();

            $.ajax({
                url: next.attr('href'),
                method: 'GET',
                dataType: 'HTML',
                success: function(data) {
                    var d = $(data).find('.infinite-scroll');
                    scrollable.append(d.children());
                    paginator = scrollable.find('.pagination');
                    loading = false;
                }
            });
        }
    });
});

/*
	Banner e popup
*/

let popup;
if (window.userType === 'parco' || window.userType === 'known') {
	popup = $('.popup-notice.popups_parco');
} else {
	popup = $('.popup-notice.popups');
}
if (!!popup?.length) {
	/*
		Ogni popup ha un identificativo, ed un cookie, proprio. Quando viene
		aggiunto un altro popup, l'utente non ha ancora un cookie per esso e
		viene dunque mostrato (anche se aveva chiuso il precedente)
	*/
	let identifier = popup.attr('data-popup-identifier');
	let control = Cookies.get(identifier);

	if (typeof control == 'undefined') {
		popup.css('display', 'flex');
		$('.commercial.sticky').remove();

		popup.find('.close-btn').click(() => {
			popup.css('display', 'none');
			Cookies.set(identifier, 'clicked', {expires: 1});
		});
	}
}

$(window).on('scroll', function () {
	const node = $('.commercial.sticky:visible');
	const reference = $('.commercial.main:visible');
	if (node && reference) {
		const top = reference.offset().top + reference.outerHeight();
		const vbottom = $(window).scrollTop();
		if (vbottom > top) {
			if (node.hasClass('animate') == false) {
				setTimeout(() => {
					node.addClass('animate');
				}, 0);
			}
		}
		else {
			node.removeClass('animate');
		}

		$('footer').css('margin-bottom', node.height() + 50);
	}
});

/*
	Footer
*/

$('.foot-menu .title').click((e) => {
	$(e.currentTarget).closest('.col').toggleClass('active');
});

/*
	Ricerca
*/

$("#searchtrigger").click(() => {
	$("#searchbar").toggleClass('open');

	_satellite.track("click-corporate", {
		"eventProperties": {
			"pageEvent": {
				category: "search",
				action: "click",
				label: "programmi_search-bar_header",
				cleanUrl: $('link[rel=canonical]').attr('href'),
			}
		}
	});
});

$("#searchbar input").autocomplete({
	source: '/search/api.php',
	minLength: 3,
	select: function(event, ui) {
		window.location = ui.item.link;
	}
}).keypress(function(e) {
	if (e.which == 13) {
		let text = $('#searchbar input').val();
		let safeTerm = encodeURIComponent(text);
		let url = '/search/?term=' + safeTerm;
		window.location = url;
	}
});

$("#searchbar input").data("ui-autocomplete")._renderItem = function(ul, item) {
	return $("<li>").append('<a href="' + item.link + '">' + item.label + '</a>').appendTo(ul);
};

$("#searchbar input").data("ui-autocomplete")._renderMenu = function (ul, items) {
	const that = this;
	$.each(items, function(index, item) {
		that._renderItemData(ul, item);
	});

	const bar = $('#searchbar');
	const text = bar.find('input').val();

	const safeTerm = encodeURIComponent(text);

	const link = $('<a>')
		.addClass('view-all')
		.attr('href', '/search/?term=' + safeTerm)
		.text('Vedi tutti i risultati');

	const last = $('<li>')
		.addClass('ui-menu-item')
		.append(link);

	$(ul).append(last);

	this.menu.element.css('max-width', bar.width());
};

$("#searchbar .void").click(() => {
	$("#searchbar").toggleClass('open');
});
